import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";

enum IconType {
  "LOCATION" = "LOCATION",
  "INSTAGRAM" = "INSTAGRAM",
  "EMAIL" = "EMAIL",
  "PHONE" = "PHONE",
  "FACEBOOK" = "FACEBOOK",
  "WEBSITE" = "WEBSITE",
}

const icons = {
  [IconType.LOCATION]: "/icons/marker.png",
  [IconType.INSTAGRAM]: "/icons/instagram.png",
  [IconType.EMAIL]: "/icons/envelope.png",
  [IconType.PHONE]: "/icons/phone.png",
  [IconType.FACEBOOK]: "/icons/facebook.png",
  [IconType.WEBSITE]: "/icons/globe.png",
};

const QuotationSocials = () => {
  const socials = [
    {
      type: IconType.LOCATION,
      label: "TIMOR LESTE DILI, MANLEUANA, Lesibutak",
    },
    {
      type: IconType.INSTAGRAM,
      label: "GESANO TOUR & TRAVEL",
    },
    {
      type: IconType.EMAIL,
      label: "gesanotour1@gmail.com",
    },
    {
      type: IconType.PHONE,
      label: "+670 77050041 / 74417115 / 76144752",
    },
    {
      type: IconType.FACEBOOK,
      label: "GESANO TOUR & TRAVEL",
    },
    {
      type: IconType.WEBSITE,
      label: "www.gesanotravelagency.com",
    },
  ];
  return (
    <View style={styles.container}>
      <Image style={styles.footerBg} src="/images/quotation-footer.png" />
      {socials.map((elm, index) => (
        <View
          style={[
            styles.socialItem,
            { width: index === 0 || index % 3 === 0 ? "40%" : "30%" },
          ]}
          key={index}
        >
          <View style={styles.socialItemImageContainer}>
            <Image src={icons[elm.type]} style={styles.socialItemImage} />
          </View>
          <Text style={styles.socialItemLabel}>{elm.label}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    rowGap: 5,
    paddingTop: 10,
    paddingBottom: 5,
    paddingRight: 24,
    paddingLeft: 24,
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 50,
    fontFamily: "Poppins",
  },
  socialItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
  },
  socialItemImageContainer: {
    width: "12",
    height: "12",
    borderRadius: "20",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#333",
  },
  socialItemImage: {
    width: "7",
    height: "7",
  },
  socialItemLabel: {
    fontSize: "7",
  },
  footerBg: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    marginLeft: -24,
    marginRight: -24,
  },
});

export default QuotationSocials;
